export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0a1628] via-[#0d1f3c] to-[#0a1628]">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-20 left-10 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-20 right-10 w-96 h-96 bg-pink-500/20 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-orange-500/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        </div>
        {/* Scanline effect */}
        <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'repeating-linear-gradient(0deg, transparent, transparent 2px, #00ffff 2px, #00ffff 4px)' }}></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto pt-20">
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/d6b4b88b420755e3ba36fdd8ab8e8672/43884c505bd2c9515d324bd839f9d0c8.jpeg"
            alt="Joysticks, Pixels & Pour Logo"
            className="w-64 h-auto sm:w-80 md:w-96 animate-pulse"
            style={{ animationDuration: '3s' }}
          />
        </div>

        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-black mb-6 tracking-tight">
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-cyan-300 to-cyan-400 drop-shadow-[0_0_30px_rgba(34,211,238,0.8)] animate-pulse" style={{ animationDuration: '2s' }}>
            JOYSTICKS,
          </span>
          <span className="block text-transparent bg-clip-text bg-gradient-to-r from-cyan-400 via-cyan-300 to-cyan-400 drop-shadow-[0_0_30px_rgba(34,211,238,0.8)] animate-pulse" style={{ animationDuration: '2s', animationDelay: '0.2s' }}>
            PIXELS & POUR
          </span>
        </h1>

        <p className="text-xl sm:text-2xl md:text-3xl text-gray-300 mb-12 font-light tracking-wide">
          Retro arcade games, craft drinks, and good times.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 mb-8">
          <button
            onClick={() => scrollToSection('drinks')}
            className="group relative px-8 py-4 bg-gradient-to-r from-cyan-500 to-cyan-600 text-white text-lg font-bold rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(34,211,238,0.6)] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">View Drinks &amp; Bites</span>
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-400 to-cyan-500 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          </button>

          <button
            onClick={() => scrollToSection('parties')}
            className="group relative px-8 py-4 bg-transparent border-2 border-pink-500 text-pink-400 text-lg font-bold rounded-lg overflow-hidden transition-all duration-300 hover:shadow-[0_0_30px_rgba(236,72,153,0.6)] hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <span className="relative z-10">Book a Party</span>
            <div className="absolute inset-0 bg-pink-500 opacity-0 group-hover:opacity-20 transition-opacity duration-300"></div>
          </button>
        </div>

        <div className="inline-flex items-center space-x-2 text-orange-400 text-sm font-mono animate-pulse">
          <span className="w-2 h-2 bg-orange-400 rounded-full"></span>
          <span>PRESS START FOR GOOD TIMES</span>
          <span className="w-2 h-2 bg-orange-400 rounded-full"></span>
        </div>
      </div>

      {/* Pixel divider at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-cyan-500 to-transparent"></div>
    </section>
  );
}
